// app/Firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent as firebaseLogEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// Analytics only works in the browser (not SSR/build), and isSupported()
// is async — so we export a promise-backed instance rather than a
// possibly-null variable that other files might read too early.
let analyticsInstance = null;
const analyticsReady =
  typeof window !== "undefined"
    ? isSupported().then((supported) => {
        if (supported) analyticsInstance = getAnalytics(app);
        return analyticsInstance;
      })
    : Promise.resolve(null);

/**
 * Safe helper — call this from anywhere in the app to log an event.
 * Does nothing if analytics isn't supported/ready yet (e.g. very first
 * click before the isSupported() check resolves — this normally takes
 * only a few ms).
 */
export const trackEvent = async (eventName, params = {}) => {
  try {
    const analytics = analyticsInstance || (await analyticsReady);
    if (analytics) {
      firebaseLogEvent(analytics, eventName, params);
    }
  } catch (err) {
    // Never let analytics failures break the UI
    console.warn("Analytics event failed:", eventName, err);
  }
};

export { app, analyticsReady };